// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__e36XE","text":"styles_text__9aPIk"};